import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import { CallTransferStatus } from '@api/generated/graphql';

export const transferStatusQuery = graphql(`
  query transferStatus($conversationSid: ID!, $transferredToAgentId: ID!) {
    transferStatus(
      sid: $conversationSid
      transferredToAgentId: $transferredToAgentId
    ) {
      status
    }
  }
`);

/**
 * Queries API for a tenant name by id
 * @param id
 * @returns tenant query results
 */
async function getTransferStatus(
  conversationSid: string,
  transferredToAgentId: string,
): Promise<CallTransferStatus> {
  const { data, error } = await getClient().query({
    query: transferStatusQuery,
    variables: { conversationSid, transferredToAgentId },
    fetchPolicy: 'network-only',
  });
  if (error) {
    throw new Error(error.message);
  }

  return data.transferStatus.status;
}

export default getTransferStatus;
